import React from 'react'
import PropTypes from 'prop-types'
import {
  HEADING_TYPE,
  BUTTON_SIZE,
  BUTTON_TYPE,
  TEXT_SIZES,
  DIVIDER_SIZE,
  COLORS,
} from '@helpers/constants'
import { SchoolGroupCardStyle } from './style'
import Heading from '@components/Heading'
import Text from '@components/Text'
import Button from '@components/Button'
import Icon from '@components/Icon'
import Divider from '@components/Divider'
import { useConfirmRemoveDemoSchoolGroup } from '@hooks/useConfirmRemoveDemoSchoolGroup'

const DemoSchoolGroupCard = (props) => {
  const {
    schoolGroup,
  } = props
  const { id, name, students, books } = schoolGroup
  const { confirmRemoveDemoSchoolGroup } = useConfirmRemoveDemoSchoolGroup(schoolGroup)

  return (
    <div className={SchoolGroupCardStyle.container}>
      <div>
        <Heading
          color={COLORS.DEMO_GREEN.TEXT}
          size={TEXT_SIZES.LARGE}
          headingLevel={HEADING_TYPE.H2}
        >
          {name}
        </Heading>
      </div>

      <div className={'absolute bg-demoGreen top-4 right-[-.5rem] py-2 px-4'}>
        <p className='text-xxSmall'>
          demo
        </p>
      </div>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <div className={'flex justify-between items-end mt-auto text-white'}>
        <div>
          <div className={'flex items-center'}>
            <Icon icon={'Classes'} />
            <Text
              color={COLORS.WHITE.TEXT}
              size={TEXT_SIZES.XXSMALL}
              extraClasses={'pl-2'}
            >
              Elever: {students?.length}
            </Text>
          </div>

          <div className={'flex items-center'}>
            <Icon icon={'Book'} />
            <Text
              color={COLORS.WHITE.TEXT}
              size={TEXT_SIZES.XXSMALL}
              extraClasses={'pl-2'}
            >
              Delade böcker: {books?.length}
            </Text>
          </div>
        </div>

        <div className={'flex'}>
          <Button
            type={BUTTON_TYPE.DARK_GREY}
            size={BUTTON_SIZE.MEDIUM}
            to={`/demogrupp/${id}`}
            margin
          >
            Visa grupp
          </Button>

          <Button
            type={BUTTON_TYPE.DARK_GREY}
            size={BUTTON_SIZE.ICON_CIRCLE}
            handleClick={confirmRemoveDemoSchoolGroup}
            icon={'Exit'}
          />
        </div>
      </div>
    </div>
  )
}

DemoSchoolGroupCard.propTypes = {
  schoolGroup: PropTypes.object,
  size: PropTypes.string,
}

export default DemoSchoolGroupCard
